import {NewTableDef, TableColumnDef} from 'app/shared/tables/table-column-def';

export interface CompetitorStoreCreateCommand {
    Name: string;
    ZipCode: string;
    City: string;
    Region0: string;
    Chain: string;
    Street: string;
    StreetNumber: number;
    Region1: string;
    Country: string;
    Surface: number;
    CheckboxNb: number;
    StockType: string;
    FridgeBeer: boolean;
    FridgeIceCream: boolean;
}

export interface CompetitorStoreUpdateCommand {
    Id: number;
    Name: string;
    ZipCode: string;
    City: string;
    Region0: string;
    Chain: string;
    Street: string;
    StreetNumber: number;
    Region1: string;
    Country: string;
    Surface: number;
    CheckboxNb: number;
    StockType: string;
    FridgeBeer: string;
    FridgeIceCream: string;
}

export interface CompetitorPricesQueryResultEntry {
    storeId: number;
    storeName: string;
    regionName: string;
    address: string;
    owner?: any;
    city: string;
}

export interface CreateCompetitorPricesCommand {
    storeName: string;
    regionName: string;
    address: string;
    owner?: string;
}

export class CreateCompetitorPrices {
    storeName = '';
    regionName = '';
    address = '';
    owner = '';
    lat = 52.237049;
    lng = 21.017532;
}

export class CompetitorPricesListQuery {
    StoreId: string;
    StoreName: string;
    StoreRegion0: string;
    StoreRegion1: string;
    StoreCity: string;
    StoreZipCode: string;
    StoreStreet: string;
    StoreStreetNumber: string;

    public static getColumnNames(): string[] {
        return [
            'StoreName',
            'StoreRegion0',
            'StoreRegion1',
            'StoreCity',
            'StoreZipCode',
            'StoreStreet',
            'StoreStreetNumber',
        ];
    }
}

export class CompetitorShopListQuery {
    AddressWithNR: string;
    City: string;
    Id: number;
    Name: string;
    Region0: string;
    Region1: string;
    ZipCode: string;

    public static tableInfo(): NewTableDef {
        return {
            tableId: 'CompetitorShopListQuery',
            columns: [
                { columnDef: 'Id' },
                {
                    field: 'Id',
                    columnDef: 'Id',
                    header: 'Id placówki',
                    width: 5,
                    showSearch: false
                },
                {
                    field: 'Name',
                    columnDef: 'Name',
                    header: 'ID placówki',
                    isGeneralSearchColumn: true,
                    width: 25,
                },
                {
                    field: 'Region0',
                    columnDef: 'Region0',
                    header: 'Województwo',
                    filterValue: 'CompStoreRegions',
                    width: 17,
                },
                {
                    field: 'Region1',
                    columnDef: 'Region1',
                    header: 'Region',
                    width: 14,
                },
                {
                    field: 'City',
                    columnDef: 'City',
                    header: 'Miasto',
                    filterValue: 'CompStoreCities',
                    width: 14,
                },
                { field: 'ZipCode', columnDef: 'ZipCode', header: 'kod pocztowy', width: 14.0833 },
                { field: 'AddressWithNR', columnDef: 'AddressWithNR', header: 'Adres', width: 25 },
            ]
        };
    }
}

export class CompetitorShopSelectListQuery {
    AddressWithNR: string;
    City: string;
    Id: number;
    Name: string;
    Region0: string;

    public static tableInfo(): Array<TableColumnDef> {
        return [
            { columnDef: 'Id' },
            {
                columnDef: 'Name',
                header: 'Nazwa placówki',
                filterValue: 'CompStoreNames',
                isGeneralSearchColumn: true,
                width: 25,
            },
            {
                columnDef: 'Region0',
                header: 'Województwo',
                filterValue: 'CompStoreRegions',
                width: 25,
            },
            {
                columnDef: 'City',
                header: 'Miasto',
                filterValue: 'CompStoreCities',
                width: 25,
            },
            { columnDef: 'AddressWithNR', header: 'Adres', width: 25 },
        ];
    }
}

export class CompetitorPricesDescriptionQuery {
    CompStoreId: number;
    CompStoreAddress: string;
    CompStoreName: string;
    CompStoreZipCode: string;
    CompStoreCity: string;
    CompStoreRegion0: string;
    CompStoreRegion1: string;
    CompStoreCountry: string;
    CompStoreChain: string;
    CompStoreSurface: number;
    CompStoreCheckboxNb: string;
    CompStoreStockType: string;
    CompStoreFridgeBeer: string;
    CompStoreFridgeIceCream: string;
    CompStoreStreet: string;
    CompStoreStreetNumber: string;
}

export class OwnStoreIDsListQuery {
    StoreId: number;
}
